<div class="container" *ngIf="(employeeList$ | async) as employeeList">
    <div class="card-list-container" *ngIf="employeeList.length > 0">
        <mat-card *ngFor="let employee of employeeList" class="employee-card" matRipple>
            <mat-card-header>
                <div mat-card-avatar class="card-header-image"
                    [style]="'background-image: url('+ employee.avatar + ');'">
                    {{(!employee.avatar) ? employee.firstName.charAt(0) : ''}}
                </div>
                <mat-card-title>{{employee.firstName}} {{employee.lastName}}</mat-card-title>
                <mat-card-subtitle>{{employee.email}}</mat-card-subtitle>
            </mat-card-header>
            <mat-card-content>
                <div>
                    <p>Job Title :</p>
                    <p>{{employee.jobTitle}}</p>
                </div>
                <div>
                    <p>Department :</p>
                    <p>{{employee.department}}</p>
                </div>
                <div>
                    <p>Company :</p>
                    <p>{{employee.company}}</p>
                </div>
                <div>
                    <p>location :</p>
                    <p>{{employee.location}}</p>
                </div>
                <div>
                    <p>Gender:</p>
                    <p>{{employee.gender}}</p>
                </div>
            </mat-card-content>
        </mat-card>
    </div>
    <div *ngIf="employeeList.length === 0">
        <img class="no-data-found-img" src="assets/no-data-found.png" />
    </div>
    <div *ngIf="(employeeList.length >= defaultPageSize) ?  true : defaultPageIndex >= 0" class="paginator-container">
        <mat-paginator [length]="100" [pageSize]="defaultPageSize" [pageIndex]="defaultPageIndex"
            [pageSizeOptions]="[5, 10, 20, 100]" (page)="onPaginatorChange($event)">
        </mat-paginator>
    </div>
</div>